import Vue from "vue";
import Vuex from "vuex";
import cache from "@/plugins/cache.js";
import settingService from "@/services/master/setting/settingService";

Vue.use(Vuex);

const SETTING_KEY = "mavsetting";
const STORE_SETTING = "STORE_SETTING";
const REMOVE_SETTING = "REMOVE_SETTING";

const state = {
  transactionCurrency: null,
  showMultiCurrency: true,
  paymentStatus: null,
  reservationStatus: null
};

const mutations = {
  [STORE_SETTING]: (state, setting) => {
    const encodedSetting = btoa(JSON.stringify(setting));
    cache.set(SETTING_KEY, encodedSetting, 300000); // 5 mins
  },
  [REMOVE_SETTING]: state => {
    cache.remove(SETTING_KEY);
  }
};

const actions = {
  getAllPublic: async ({ commit }) => {
    try {
      // get from cache
      let publicSettings = cache.get(SETTING_KEY);
      if (
        publicSettings !== undefined &&
        publicSettings !== null &&
        publicSettings !== ""
      ) {
        return JSON.parse(atob(publicSettings));
      }

      // clean storage
      commit(REMOVE_SETTING);

      // get from API
      publicSettings = await settingService.getAllPublic();

      // store to local storage
      commit(STORE_SETTING, publicSettings);

      return publicSettings;
    } catch (error) {
      commit(REMOVE_SETTING);
      throw new Error(error);
    }
  },
  removeSetting: ({ commit }) => {
    try {
      // clean storage
      commit(REMOVE_SETTING);
    } catch (error) {
      throw new Error(error);
    }
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/setting.js